<script lang="ts" setup></script>

<template>
  <div class="v-company-child"></div>
</template>

<style lang="scss" scoped></style>
